import { render, staticRenderFns } from "./ElraReport8DevNextSteps.vue?vue&type=template&id=615b1553&scoped=true"
import script from "./ElraReport8DevNextSteps.vue?vue&type=script&lang=ts"
export * from "./ElraReport8DevNextSteps.vue?vue&type=script&lang=ts"
import style0 from "./ElraReport8DevNextSteps.vue?vue&type=style&index=0&id=615b1553&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615b1553",
  null
  
)

export default component.exports